import { atom } from 'recoil';

export const pendingNotificationsCountAtom = atom<number | undefined>({
	key: 'pendingNotificationsCount',
	default: undefined,
});
